import { useCallback, useEffect } from "react";
import { createTheme, ThemeProvider, responsiveFontSizes } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import "./App.css";

import { getFingerprint } from "src/library/plugins/plugins";
import AppRouter, { generateRouteMap } from "src/routes/AppRouter";
import { Footer } from "src/library/components/exports";
import { hackathonTheme } from "src/library/styles/theme";
import { useHackathonContext, ACTIONS } from "src/library/store/GlobalStateProvider";
import { RegisterPayload } from "src/library/types/types";
import { initialFormData } from "src/library/store/initialState";
import { Header } from "src/library/components/exports";
import { FORM_ENABLED, REGISTRATIONS_CLOSE_TIME } from "./library/constants";
import { calcTimeDelta } from "react-countdown";

function App() {
  const { dispatch } = useHackathonContext();
  const setGlobalState = useCallback(
    (initialData: RegisterPayload) =>
      dispatch({ type: ACTIONS.UPDATE_FORM_DATA, payload: initialData }),
    [dispatch]
  );

  useEffect(() => {
    // GENERATES ROUTE MAP FROM ENUMS FOR NAV MENU ITEMS
    generateRouteMap();

    // GET CLIENT FINGERPRINT
    (async () => {
      let fp = { visitorId: initialFormData.fingerprint, components: {} };
      if (process.env.REACT_APP_FINGERPRINT_ENABLED !== "false") {
        fp = await getFingerprint();
      }

      // SET EMPTY FORM DATA
      setGlobalState({
        ...initialFormData,
        fingerprint: fp.visitorId,
        components: JSON.stringify(fp.components),
      });
    })();

    const { completed } = calcTimeDelta(REGISTRATIONS_CLOSE_TIME);

    if (completed) {
      dispatch({ type: ACTIONS.FORM_AVAILABLE, payload: false });
    }

    if (!completed && !FORM_ENABLED) {
      dispatch({ type: ACTIONS.FORM_AVAILABLE, payload: false });
    }

    // INITIALIZE SCROLL LIBRARY
    AOS.init();
  }, [setGlobalState, dispatch]);

  let theme = createTheme(hackathonTheme);
  theme = responsiveFontSizes(theme);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header>
          <AppRouter />
        </Header>
        <Footer />
      </ThemeProvider>
    </div>
  );
}

export default App;
